module.exports = __webpack_public_path__ + "static/dot-grid-purple-50066952735075842703229f84ce7a9a.png";